export type AllOrNone<T extends Record<string, unknown>> = T | Partial<Record<keyof T, never>>;
